export const ACTION_TYPE = {
  MAIN_BET: 1,
  SIDE_BET: 2,
  DOUBLE: 3,
  RE_BET: 4,
};
export const ADDITIONAL_PARAMS_TYPE = {
  MAIN_BET: 0,
  SPLIT_BET: 1,
  DOUBLE: 2,
  INSURANCE_BET: 3,
};
export const SIDE_BET_TYPE = {
  PERFECT_PAIR: 1,
  BLACK_JACK_PLUS_3: 2,
};

export const SIDE_BETS_WIN_TYPES = {
  0: 'PERFECT_PAIR',
  1: 'COLORED_PAIR',
  2: 'MIXED_PAIR',
  3: 'SUITED_TRIPS',
  4: 'STRAIGHT_FLUSH',
  5: 'THREE_OF_A_KIND',
  6: 'STRAIGHT',
  7: 'FLUSH',
};

export const SIDE_BET_TYPE_BY_BET_DATA = {
  1: 'PERFECT_PAIR',
  2: 'BLACK_JACK_PLUS_3',
};

export const SIDE_BET_TYPE_IN_HISTORY = {
  1: 'P_P',
  2: '21+3',
};

export const SIDE_BETS_NAMES_P_P = {
  6: 'MIXED_PAIR',
  13: 'COLORED_PAIR',
  26: 'PERFECT_PAIR',
};

export const SIDE_BETS_NAMES_21_3 = {
  6: 'FLUSH',
  11: 'STRAIGHT',
  31: 'THREE_OF_A_KIND',
  41: 'STRAIGHT_FLUSH',
  101: 'SUITED_TRIPS',
};

export const SIDE_BET = {
  1: 'perfectPair',
  2: 'blackJackPlus3',
};

export const CHIP_BET_TYPE = {
  0: 'main',
  1: 'sidePerfectPair',
  2: 'side21plus3',
};

export const SIDE_BET_TYPES_NAMES = {
  0: 'MAIN',
  1: 'SIDE_PERFECT_PAIR',
  2: 'SIDE_21_PLUS_3',
};

export const BET_TYPE = {
  main: 0,
  sidePerfectPair: 1,
  side21plus3: 2,
};

export const BET_TYPE_ODD = {
  side21plus3Odd: 'side21plus3Odd',
  sidePerfectPairOdd: 'sidePerfectPairOdd',
};
